/**
 * Format a Date object to a YYYY-MM-DD string.
 */
export const formatDate = (date: Date): string => {
  const [dateStr] = date.toISOString().split('T');
  return dateStr;
};

/**
 * Safely format a date string to a locale string.
 * Returns a fallback value if the date is invalid.
 */
export const formatDateSafe = (
  value: unknown,
  fallback: string = '-',
): string => {
  if (!value) return fallback;
  const date = new Date(String(value));
  if (Number.isNaN(date.getTime())) return fallback;
  return date.toLocaleString();
};
